import { Style } from "../../../../core/models/entities/Style";
import { StrucRow } from "../../../components/StructureElements/StrucRow";
import { StrucCol } from "../../../components/StructureElements/StrucCol";
import { imageFallback } from "../../../shared/const/imageFallback";
import React from "react";
import { useTranslation } from "react-i18next";

export function StyleCard({
  style,
  onClick,
  isSelected,
}: {
  style: Style;
  onClick: (style: Style) => void;
  isSelected: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`cursor-pointer border h-20 rounded py-2 ${isSelected ? "bg-gray-100" : ""}`}
      onClick={() => onClick(style)}
    >
      <StrucRow>
        <StrucCol size={3}>
          <img
            className={"object-contain h-16"}
            // List cards render at ~112x64px - the 0.6-1.1 MB high-res PNGs made a
            // cold picker load 30-50 MB. Low-res (~63 KB) with high-res fallback for
            // styles where the low-res blob is missing.
            src={
              style.thumbnailUrlLowResolution ||
              style.thumbnailUrl ||
              imageFallback
            }
            onError={(e) => {
              const img = e.currentTarget;
              const fallback = style.thumbnailUrl || imageFallback;
              if (fallback && img.src !== fallback) img.src = fallback;
            }}
          />
        </StrucCol>
        <StrucCol className={"space-y-1"}>
          <div>
            <p>
              <b>{t("model")} </b>
              {style.modelAndName}
            </p>
          </div>
          <div>
            <p>
              <b>{t("manufacturer")} </b>
              {style.manufacturer.name}
            </p>
          </div>
        </StrucCol>
      </StrucRow>
    </div>
  );
}
